module.exports = __webpack_public_path__ + "static/media/pyv-auto-tracking.0c7ef6ec.gif";